export default "__VITE_ASSET__CkdYTxDf__"